'use client';

import { Box, Skeleton } from '@mui/material';

import { ButtonSkeleton } from './common/ButtonSkeleton';

// Mirrors the authenticated header row: Deposit, Referral, PortfolioBalances,
// StreakProgressPill, NotificationBell, UserSettingsMenu.
export const HeaderActionsSkeleton = () => {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
      <ButtonSkeleton
        width={90}
        height={32}
        borderRadius="9px"
        sx={{ display: { xs: 'none', md: 'block' } }}
      />
      <ButtonSkeleton
        width={100}
        height={32}
        borderRadius="9px"
        sx={{ display: { xs: 'none', md: 'block' } }}
      />
      <Skeleton
        variant="rounded"
        width={160}
        height={40}
        sx={{ display: { xs: 'none', md: 'block' }, borderRadius: '10px' }}
      />
      <Skeleton
        variant="rounded"
        width={120}
        height={40}
        sx={{ display: { xs: 'none', md: 'block' }, borderRadius: '12px' }}
      />
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton
        variant="circular"
        width={32}
        height={32}
        sx={{ display: { xs: 'none', md: 'block' }, ml: 1 }}
      />
    </Box>
  );
};
